import { Button } from "react-bootstrap";

export function ButtonParent(props: { children: React.ReactNode, onClick: (event?: any) => void, title: string, variant?: string, className?: string, disabled?: boolean, style?: any }) {
  const { children, onClick, title, variant, className, disabled, style } = props;
  const buttonVariant = variant || 'secondary';
  return (
    <div>
      <Button 
        onClick={onClick} 
        title={title}
        className={className || "btn btn-sm" }
        style={{ ...style, minHeight: '32px' }}
        variant={buttonVariant}
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  );
}